import { createReducer, on } from '@ngrx/store';
import { alertsInitialState, AlertsState } from '@store/states/alerts.state';
import { alertsActions } from '@store/actions/alerts.actions';

export const alertsReducer = createReducer(
  alertsInitialState,
  on(alertsActions.setAlerts, (state, { data }): AlertsState => ({ ...state, data: [...data], error: null })),
  on(alertsActions.errorAlerts, (state, { error }): AlertsState => ({ ...state, data: [], error })),
  on(alertsActions.filterAlerts, (state, { filter }): AlertsState => ({ ...state, filter })),
  on(alertsActions.sortAlerts, (state, { sort }): AlertsState => ({ ...state, sort }))
);
